export default "__VITE_ASSET__5feefa07__"